import { Component, OnInit, ElementRef, ViewChild, Input } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { ErrorHandlerService } from "src/app/shared/services/error-handler/error-handler.service";
import { FileUploader, FileItem, ParsedResponseHeaders } from "ng2-file-upload";
import { concat, of, Observable, Subject, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap,
  catchError,
} from "rxjs/operators";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { CommonHttpService } from "src/app/shared/services/common-http/common-http.service";
import {
  serverUrl,
  Modalconfig,
  linkPattern,
  imageGifAllowedExtension,
} from "src/app/shared/constants";
import { ImageGroup, ImageBlock } from "src/app/shared/model/container.models";
import { AuthService } from "src/app/core/authentication/auth.service";
import { ConfirmationModelComponent } from "src/app/shared/components/confirmation-model/confirmation-model.component";
import { findIndex, includes, reject, sortBy } from "lodash";
import { UtilitiesService } from "src/app/shared/services/utilities/utilities.service";
const URL = serverUrl + "/api/Assets/UploadImage/";
@Component({
    selector: "app-editimage",
    templateUrl: "./editimage.component.html",
    styleUrls: ["./editimage.component.scss"],
    standalone: false
})
export class EditimageComponent implements OnInit {
  companyId: number;
  pageid: number;
  playbookId: number;
  extensionErrorMessage: string;
  imageAllowedExtensions = imageGifAllowedExtension;
  imageChangedEvent: any = "";
  imageName: any;
  uploadImageForm: UntypedFormGroup;
  editImageGroupForm: UntypedFormGroup;
  selectedFile: any;
  uploadResponse: any;
  languageId: number;
  contentBlockId: number;
  groupId: number;
  dataSubmitted = false;
  errMessage: string;
  disableEnlargeImage = false;
  enlargeImageValue: boolean;
  valueExist: boolean;
  activePill = true;
  progressbarDisplay = {
    image: false,
  };
  dynamicProgressbar = {
    image: null,
  };
  max = 100;
  setup = {
    device_pixel_ratio: window.devicePixelRatio,
  };
  responseImageData: any;
  imageGroupDetail: any;
  people3$: Observable<any[]>;
  people3Loading = false;
  people3input$ = new Subject<string>();
  selectedPersons: any[] = [];
  items: any;
  submitted: boolean;
  errorMessage: string;
  selectedGroupId: number;
  observeSubcribtion: Subscription;
  isGroupEditable = false;
  selectedImageGroup: any;
  meesageDeleteImageGroup =
    "Are you sure you would like to delete this slideshow? All images uploaded to this group will be removed.";

  currentImageGroup: any;
  serverUrl = serverUrl;
  imageBlocksPlaybookTranslation: any;
  profileId: number;
  confModalRef: BsModalRef;
  updateContainer = new Subject();
  public uploader: FileUploader;
  public hasBaseDropZoneOver = false;
  public hasAnotherDropZoneOver = false;
  @ViewChild("fileInputImage") fileInputImage: ElementRef;
  @ViewChild("fileInput") fileInput: ElementRef;
  @Input() lockDefaultLangaugeData;
  constructor(
    private commonHttpService: CommonHttpService,
    private modalRef: BsModalRef,
    private modalService: BsModalService,
    private authService: AuthService,
    private errorHandlerService: ErrorHandlerService,
    private formBuilder: UntypedFormBuilder,
    private utilitiesService: UtilitiesService
  ) {
    this.fileUploader();
    this.createUploadImageForm();
  }
  clearImageOnClick() {
    if (this.fileInputImage) {
      this.fileInputImage.nativeElement.value = null;
    }
  }
  clearSlideShowImages() {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = null;
    }
  }
  fileUploader() {
    this.uploader = new FileUploader({ url: URL });
    this.uploader.onErrorItem = (item, response, status, headers) =>
      this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) =>
      this.onSuccessItem(item, response, status, headers);
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = true;
      this.onFileChange();
    };
  }
  onSuccessItem(
    item: FileItem,
    response: string,
    status: number,
    headers: ParsedResponseHeaders
  ): any {
    const result = JSON.parse(response).Result;
    if (status === 200) {
      const reqObj = {
        playbookId: this.playbookId,
        imageGroupId: this.selectedImageGroup.id,
        imageId: result.id,
        languageId: this.languageId,
      };
      this.commonHttpService
        .post({
          uri: "/api/ImageBlocks/AddImageToImageGroup",
          object: reqObj,
        })
        .subscribe((resp: ImageGroup) => {
          this.selectedImageGroup = resp;
          this.imageGroupDetail = this.selectedImageGroup.imageGroupDetail;
          const imageGroupIndex = this.findImageGroupIndex(this.items, resp.id);
          if (imageGroupIndex !== -1) {
            this.items[imageGroupIndex] = resp;
          }
        });
    }
  }

  onErrorItem(
    item: FileItem,
    response: string,
    status: number,
    headers: ParsedResponseHeaders
  ): any {}
  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }
  ngOnInit() {
    this.submitted = false;
    this.editImageGroupForm = this.formBuilder.group({
      editImageGroupName: [
        null,
        [Validators.required, Validators.maxLength(200)],
      ],
    });
    this.getEachImage(this.imageBlocksPlaybookTranslation, this.pageid);
  }

  another(selectedItem) {
    if (selectedItem) {
      this.selectedImageGroup = selectedItem;
      if (selectedItem.name && !selectedItem.id) {
        const reqObj = {
          name: selectedItem.name,
          playbookId: this.playbookId,
          languageId: this.languageId,
        };

        this.commonHttpService
          .post({
            uri: "/api/ImageBlocks/AddImageGroup",
            object: reqObj,
          })
          .subscribe(
            (response: ImageGroup) => {
              this.items = [...this.items, response];
              this.selectedImageGroup = response;
            },
            (err) => {
              console.log(err);
            }
          );
      }
      const imageGroupIndex = this.findImageGroupIndex(
        this.items,
        selectedItem.id
      );
      this.imageGroupDetail = selectedItem.imageGroupDetail
        ? imageGroupIndex !== -1
          ? this.items[imageGroupIndex].imageGroupDetail
          : []
        : [];
      this.imageGroupDetail = sortBy(this.imageGroupDetail, "order");
    } else {
      this.imageGroupDetail = [];
    }
  }

  customSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.name.toLocaleLowerCase().indexOf(term) > -1;
  }

  trackByFn(item: any) {
    return item.id;
  }

  getPeople(term: string = null): Observable<any[]> {
    let itemsfound;
    itemsfound = term
      ? this.items.filter(
          (x) =>
            x.name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1
        )
      : this.items;
    return of(itemsfound);
  }

  private loadPeople3() {
    this.people3$ = concat(
      of(this.items),
      this.people3input$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => (this.people3Loading = true)),
        switchMap((term: string) =>
          this.getPeople(term).pipe(
            catchError(() => of(["Something went wrong"])), // empty list on error
            tap(() => (this.people3Loading = false))
          )
        )
      )
    );
  }

  createUploadImageForm() {
    this.uploadImageForm = this.formBuilder.group({
      enlargeImage: [true],
      linkUrl: [null, [Validators.pattern(linkPattern)]],
      agree: [null],
    });
    this.onLinkChange();
  }
  get form() {
    return this.uploadImageForm.controls;
  }
  get linkUrl() {
    return this.uploadImageForm.get("linkUrl");
  }
  get enlargeImage() {
    return this.uploadImageForm.get("enlargeImage");
  }
  get agree() {
    return this.uploadImageForm.get("agree");
  }
  updateAllFormControls() {
    let imageGroupIndex = 0;
    if (
      this.responseImageData.imageGroup &&
      this.responseImageData.imageGroup.name
    ) {
      imageGroupIndex = findIndex(
        this.currentImageGroup,
        (eachImageGroupIndex: any) =>
          eachImageGroupIndex.id === this.responseImageData.imageGroup.id
      );
    }
    this.uploadImageForm.setValue({
      linkUrl: this.responseImageData.linkURL
        ? this.responseImageData.linkURL
        : null,
      enlargeImage: this.responseImageData.enableImageAction
        ? this.responseImageData.enableImageAction
        : null,
      agree: this.currentImageGroup[imageGroupIndex]
        ? this.currentImageGroup[imageGroupIndex].name
        : "",
    });
    this.selectedImageGroup = this.currentImageGroup[imageGroupIndex]
      ? this.currentImageGroup[imageGroupIndex]
      : null;
    this.imageGroupDetail = this.currentImageGroup[imageGroupIndex]
      ? this.currentImageGroup[imageGroupIndex].imageGroupDetail
      : [];
  }

  handleEnalargeImageCheckbox(enlargeImageValue, disableEnlargeImageValue) {
    this.uploadImageForm.patchValue({
      enlargeImage: enlargeImageValue,
    });
    this.disableEnlargeImage = disableEnlargeImageValue;
  }
  onLinkChange() {
    this.linkUrl.valueChanges.subscribe((value) => {
      if (!this.valueExist) {
        this.enlargeImageValue = this.enlargeImage.value;
      }
      if (value) {
        this.valueExist = true;
        this.handleEnalargeImageCheckbox(true, true);
      } else {
        this.valueExist = false;
        this.handleEnalargeImageCheckbox(this.enlargeImageValue, false);
      }
    });
  }
  setAllNewValue(imageBlocksPlaybookTranslation) {
    this.items = [];
    this.imageGroupDetail = [];
    this.contentBlockId = imageBlocksPlaybookTranslation.contentBlockId;
    this.groupId = imageBlocksPlaybookTranslation.groupId;
    this.languageId = imageBlocksPlaybookTranslation.languageId;
    this.dynamicProgressbar.image = null;
    this.progressbarDisplay.image = false;
  }
  getEachImage(imageBlocksPlaybookTranslation, pageno) {
    this.submitted = false;
    this.setAllNewValue(imageBlocksPlaybookTranslation);
    this.items = this.currentImageGroup;
    this.loadPeople3();
    this.commonHttpService
      .get({
        uri: `/api/Translation/GetImageBlockWithImageGroupForTranslation?playbookId=${this.playbookId}&companyId=${this.companyId}&languageId=${this.languageId}&contentBlockId=${imageBlocksPlaybookTranslation.contentBlockId}`,
      })
      .subscribe((responseImageData) => {
        this.responseImageData = responseImageData;
        this.updateAllFormControls();
      });
  }
  asignNullObject() {
    this.responseImageData = {
      asset: {},
      assetId: null,
      caption: null,
      enableImageAction: true,
      hotspotEditedHtmlString: null,
      hotspotHtmlString: null,
      id: null,
      imageGroup: {},
      imageGroupId: null,
      linkURL: null,
      url: null,
    };
    this.uploadImageForm.setValue({
      linkUrl: null,
      enlargeImage: true,
      agree: this.currentImageGroup[0] ? this.currentImageGroup[0].name : "",
    });
    this.selectedImageGroup = this.currentImageGroup[0]
      ? this.currentImageGroup[0]
      : null;
    this.imageGroupDetail = this.currentImageGroup[0]
      ? this.currentImageGroup[0].imageGroupDetail
      : [];
  }
  checkExtensionFunction(selectedFile, extensionAllowedArray) {
    const extensionArray = selectedFile.name.split(".");
    const extension = extensionArray[extensionArray.length - 1].toLowerCase();
    return includes(extensionAllowedArray, extension);
  }

  fileChangeEvent(event: any, extensionAllowedArray: Array<any>): void {
    if (event.target.files[0] !== undefined) {
      this.selectedFile = event.target.files[0];
      this.imageChangedEvent = event;
      this.imageName = event.target.files[0].name;
      const checkExtension = this.checkExtensionFunction(
        this.selectedFile,
        extensionAllowedArray
      );
      if (checkExtension) {
        this.upload();
      } else {
        const isAre = extensionAllowedArray.length > 1 ? "are" : "is";
        const extensionErrorMessage =
          "This is not a valid extension. Supported extensions " +
          isAre +
          " : " +
          extensionAllowedArray.join(",") +
          ".";
        alert(extensionErrorMessage);
      }
    }
  }
  upload() {
    const formData: FormData = new FormData();
    formData.append("file", this.selectedFile);
    this.progressbarDisplay.image = true;
    this.dynamicProgressbar.image = 0;
    if (this.observeSubcribtion) {
      this.observeSubcribtion.unsubscribe();
    }
    this.commonHttpService
      .postWithProgress({
        uri: "/api/Assets/UploadImage",
        object: formData,
      })
      .subscribe(
        (response: any) => {
          if (typeof response === "number") {
            // To display progress bar while file is being uploaded
            this.dynamicProgressbar.image = response;
          } else if (response) {
            this.progressbarDisplay.image = false;
            this.uploadResponse = response;
            this.responseImageData.asset = this.uploadResponse;
            this.responseImageData.assetId = this.uploadResponse.id;
            this.responseImageData.url =
              "/assets/resource/" + this.uploadResponse.id;
            this.progressbarDisplay.image = false;
          }
        },
        (error) => {
          this.progressbarDisplay.image = false;
          this.errorHandlerService.handleError(error);
        }
      );
  }
  save() {
    this.dataSubmitted = true;
    if (this.uploadImageForm.invalid) {
      return true;
    }
    const imageObj = {
      id: this.responseImageData.id,
      playbookId: this.playbookId,
      assetId: this.responseImageData.assetId
        ? this.responseImageData.assetId
        : null,
      contentBlockId: this.imageBlocksPlaybookTranslation.contentBlockId,
      caption: this.responseImageData.caption
        ? this.responseImageData.caption
        : null,
      hotspotEditedHtmlString: this.responseImageData.hotspotEditedHtmlString
        ? this.responseImageData.hotspotEditedHtmlString
        : null,
      enableImageAction: this.enlargeImage ? this.enlargeImage.value : false,
      hotspotHtmlString: this.responseImageData.hotspotHtmlString
        ? this.responseImageData.hotspotHtmlString
        : null,
      linkURL: this.linkUrl ? this.linkUrl.value : null,
      languageId: this.languageId,
      imageGroupId: !this.selectedImageGroup
        ? this.responseImageData.imageGroupId
          ? this.responseImageData.imageGroupId
          : null
        : this.selectedImageGroup.id,
    };
    if (imageObj.id) {
      this.commonHttpService
        .put({
          uri: "/api/ImageBlocks/UpdateImageBlock",
          object: imageObj,
        })
        .subscribe((response: ImageBlock) => {
          this.updateContainer.next({
            imageBlocksPlaybookTranslation: this.imageBlocksPlaybookTranslation,
            response,
          });
          this.modalRef.hide();
        });
    }
  }
  deleteUploadedImage(imageGroup) {
    const reqObj = {
      playbookId: this.playbookId,
      imageGroupId: imageGroup.imageGroupId,
      imageId: imageGroup.id,
      languageId: this.languageId,
    };
    this.commonHttpService
      .deleteWithBody({
        uri: "/api/ImageBlocks/DeleteGroupImage",
        object: reqObj,
      })
      .subscribe((res: ImageGroup) => {
        this.selectedImageGroup = res;
        this.imageGroupDetail = res.imageGroupDetail;
        const imageGroupIndex = this.findImageGroupIndex(this.items, res.id);
        if (imageGroupIndex !== -1) {
          this.items[imageGroupIndex] = res;
        }
      });
  }
  getImageGroup(ImageGroupId) {
    const imageIndex = findIndex(this.currentImageGroup, (imageObj: any) => {
      return imageObj.id === ImageGroupId;
    });
    return imageIndex === -1 ? 0 : imageIndex;
  }
  initializeAllObject() {
    this.isGroupEditable = false;
    this.responseImageData.assetId = null;
    this.responseImageData.asset = null;
    this.activePill = true;
  }
  onFileChange() {
    let fileUploadNotValidExtensions = 0;
    const agreeValue = !this.selectedGroupId
      ? this.responseImageData.imageGroup &&
        this.responseImageData.imageGroup.id
        ? this.responseImageData.imageGroup.id
        : this.currentImageGroup[0].id
      : this.selectedGroupId;

    this.uploader.queue.map((item) => {
      // tslint:disable-next-line: no-string-literal
      if ((!item.isUploaded || item.isUploading) && !item["checked"]) {
        const checkExtension = this.checkExtensionFunction(
          item.file,
          this.imageAllowedExtensions
        );
        if (checkExtension) {
          this.uploader.setOptions({
            url: URL,
            authToken: this.authService.authorizationHeaderValue(),
            headers: [
              {
                name: "X-XSRF-TOKEN",
                value: this.utilitiesService.getCookie("XSRF-TOKEN"),
              },
            ],
            removeAfterUpload: false,
          });
          this.uploader.uploadItem(item);
        } else {
          fileUploadNotValidExtensions++;
        }
      }
      // tslint:disable-next-line: no-string-literal
      item["checked"] = true;
    });
    if (fileUploadNotValidExtensions) {
      this.extensionErrorMessage =
        "This is not a valid extension. Supported extensions are : " +
        this.imageAllowedExtensions.join(",") +
        ".";
      alert(this.extensionErrorMessage);
    }
  }
  unsubcribeAll() {
    if (this.uploader.queue) {
      this.uploader.queue.map((obj) => {
        this.uploader.removeFromQueue(obj);
      });
    }
    this.uploader.clearQueue();
    if (this.observeSubcribtion) {
      this.observeSubcribtion.unsubscribe();
    }
  }
  get editImageGroupFormControl() {
    return this.editImageGroupForm.controls;
  }
  setEditableGroupName() {
    this.isGroupEditable = true;
    this.editImageGroupForm.patchValue({
      editImageGroupName: this.selectedImageGroup.name,
    });
  }
  checkForValidGroupText(groupText) {
    return (
      groupText === undefined ||
      groupText === null ||
      groupText.toString().trim() === ""
    );
  }
  cancleGroupUpdate() {
    this.isGroupEditable = false;
  }
  deleteImageGroup(group) {
    const initialState = {
      msg: "Are you sure you would like to delete this slideshow? All images uploaded to this group will be removed.",
    };
    this.confModalRef = this.modalService.show(
      ConfirmationModelComponent,
      Object.assign({ initialState }, { class: "custom-modal" }, Modalconfig)
    );
    this.confModalRef.content.onclose.subscribe((res) => {
      if (res) {
        const reqObj = {
          playbookId: this.playbookId,
          groupId: group.id,
          languageId: this.languageId,
        };
        this.commonHttpService
          .deleteWithBody({
            uri: "/api/ImageBlocks/DeleteImageGroup",
            object: reqObj,
          })
          .subscribe((response) => {
            this.selectedImageGroup = null;
            this.imageGroupDetail = [];
            this.items = reject(this.items, (item) => {
              return item.id === group.id;
            });
            this.updateImageGroupDropdown();
            this.confModalRef.hide();
          });
      } else {
        this.confModalRef.hide();
      }
    });
  }
  assignDefault(getImageGroup: any) {
    const Imageindex = findIndex(getImageGroup, (singlegetImageGroup) => {
      return singlegetImageGroup["isDefault"];
    });
    this.another(getImageGroup[Imageindex]);
  }

  findImageGroupIndex(
    imageGroupList: ImageGroup[],
    updatedImageGroupId: number
  ) {
    return findIndex(imageGroupList, (imageGroup) => {
      return imageGroup.id === updatedImageGroupId;
    });
  }

  /**
   * Method to update image group name
   */
  updateImageGroup() {
    this.submitted = true;
    if (this.editImageGroupForm.invalid) {
      return true;
    }
    const reqObj = {
      id: this.selectedImageGroup.id,
      name: this.editImageGroupForm.value.editImageGroupName,
      playbookId: this.playbookId,
      languageId: this.languageId,
    };
    this.commonHttpService
      .put({
        uri: "/api/ImageBlocks/UpdateImageGroup",
        object: reqObj,
      })
      .subscribe((response: ImageGroup) => {
        this.isGroupEditable = false;
        const imageGroupIndex = this.findImageGroupIndex(
          this.items,
          response.id
        );
        if (imageGroupIndex !== -1) {
          this.items[imageGroupIndex] = response;
        }
        this.selectedImageGroup.name =
          this.editImageGroupForm.value.editImageGroupName;
        this.updateImageGroupDropdown();
        this.submitted = false;
      });
  }
  updateImageGroupDropdown() {
    this.loadPeople3();
    this.uploadImageForm.patchValue({
      agree: this.selectedImageGroup ? this.selectedImageGroup.name : null,
    });
  }
  closeModal() {
    this.modalRef.hide();
  }
}
